
    import { tbase } from '@/i18n';
    import { Options, Vue } from 'vue-class-component';

    // clone of:
    // import { slots } from '@vuepic/vue-datepicker/src/VueDatePicker/components/composables/slots';
    export const slots = [
        { name: 'clock-icon', use: ['time', 'calendar'] },
        { name: 'arrow-left', use: ['month-year', 'calendar'] },
        { name: 'arrow-right', use: ['month-year', 'calendar'] },
        { name: 'arrow-up', use: ['time', 'calendar'] },
        { name: 'arrow-down', use: ['time', 'calendar'] },
        { name: 'calendar-icon', use: ['month-year', 'time', 'calendar'] },
        { name: 'day', use: ['calendar'] },
        { name: 'month-overlay-value', use: ['calendar', 'month-year'] },
        { name: 'year-overlay-value', use: ['calendar', 'month-year'] },
        { name: 'year-overlay', use: ['month-year'] },
        { name: 'month-overlay', use: ['month-year'] },
        { name: 'month-overlay-header', use: ['month-year'] },
        { name: 'year-overlay-header', use: ['month-year'] },
        { name: 'hours-overlay-value', use: ['calendar', 'time'] },
        { name: 'minutes-overlay-value', use: ['calendar', 'time'] },
        { name: 'seconds-overlay-value', use: ['calendar', 'time'] },
        { name: 'hours', use: ['calendar', 'time'] },
        { name: 'minutes', use: ['calendar', 'time'] },
        { name: 'month', use: ['calendar', 'month-year'] },
        { name: 'year', use: ['calendar', 'month-year'] },
        { name: 'action-select', use: ['action'] },
        { name: 'action-preview', use: ['action'] },
        { name: 'calendar-header', use: ['calendar'] },
        { name: 'marker-tooltip', use: ['calendar'] },
        { name: 'now-button', use: [] },
        { name: 'time-picker-overlay', use: ['calendar', 'time'] },
        { name: 'am-pm-button', use: ['calendar', 'time'] },
        { name: 'left-sidebar', use: ['menu'] },
        { name: 'right-sidebar', use: ['menu'] },
        { name: 'month-year', use: ['month-year'] },
        { name: 'time-picker', use: ['menu'] },
        { name: 'action-row', use: ['menu'] },
    ];

    @Options<ApDate>({
        props: {
            enableTimePicker: {
                default: false,
            },
            autoApply: {
                default: true,
            },
            modelType: {
                default: 'dd/MM/yyyy',
            },
            format: {
                default: 'dd/MM/yyyy',
            },
            'min-date': {
                default: null,
            },
        },
    })
    export default class ApDate extends Vue {
        public readonly range!: string;
        public readonly format!: any;
        public dayNames: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        public allSlots = slots;

        mounted() {
            this.dayNames = this.dayNames.map((x) => tbase('calendar.day-names', x));
        }
    }
